var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.max_reward_per_store,
          expression: "max_reward_per_store",
        },
      ],
      ref: "max_reward_per_store",
      staticClass: "form-control",
      attrs: {
        type: "number",
        min: "0",
        max: "1000000",
        disabled: !_vm.canEdit,
        name: "max_reward_per_store",
      },
      domProps: { value: _vm.max_reward_per_store },
      on: {
        change: _vm.update,
        input: function ($event) {
          if ($event.target.composing) {
            return
          }
          _vm.max_reward_per_store = $event.target.value
        },
      },
    }),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "form-control-label" }, [
      _c("h4", [
        _vm._v("Max Reward Per Store "),
        _c("span", [_vm._v("(baht, max 1000000)")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }